import { render, staticRenderFns } from "./AzvLookup.vue?vue&type=template&id=4b851044&"
import script from "./AzvLookup.vue?vue&type=script&lang=js&"
export * from "./AzvLookup.vue?vue&type=script&lang=js&"
import style0 from "./AzvLookup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports